/**
 * WF-Layout styles for Shadow DOM
 */

import { css } from 'lit';

export const wfLayoutStyles = css`
  :host {
    display: block;
    box-sizing: border-box;
  }

  :host([hidden]) {
    display: none;
  }

  /* Width classes */
  :host(.wf-layout--width-full) {
    width: 100%;
  }

  :host(.wf-layout--width-auto) {
    width: auto;
  }

  :host(.wf-layout--width-fit) {
    width: fit-content;
  }
`;
